import type { Icon, IconWeight } from "@phosphor-icons/react";

interface PhosphorIconProps {
    phosphorIcon: Icon;
    color?: string;
    fontSize?: string;
    weight?: IconWeight;
}

export const PhosphorIcon = (props: PhosphorIconProps) => {
    const IconComponent = props.phosphorIcon;
    const className = [props.color, props.fontSize, "flex items-center justify-center shrink-0"]
        .filter(Boolean)
        .join(" ");
    return (
        <IconComponent
            className={className}
            weight={props.weight}
            aria-hidden="true"
        />
    );
};
